import ContextMenu, {ContextMenuTrigger} from './ContextMenu';

export {
  ContextMenuTrigger
};

export default ContextMenu;
